// Shown in place of content whose fetch failed. Always pairs the message with a
// retry, because the drawers that use it stay mounted after a failure — without
// one there is no way back short of navigating away.
import { useTranslation } from 'react-i18next';
import { Button } from './base/Button';
import styles from './LoadError.module.css';

interface LoadErrorProps {
  message: string;
  onRetry: () => void;
}

export const LoadError = ({ message, onRetry }: LoadErrorProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.loadError} role="alert">
      <span className={styles.message}>{message}</span>
      <Button type="secondary" onClick={onRetry}>
        {t('retry')}
      </Button>
    </div>
  );
};
